export interface TeamMember {
  id: string;
  name: string;
  profession: string;
  university: string;
  role: string;
  initials: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: "julio-espinoza",
    name: "Julio Espinoza Toro",
    profession: "Ingeniero Civil Industrial",
    university: "Pontificia Universidad Católica",
    role: "Socio de IML",
    initials: "JE",
  },
  {
    id: "jaime-mordojovich",
    name: "Jaime Mordojovich Soto",
    profession: "Constructor Civil",
    university: "Pontificia Universidad Católica",
    role: "Socio de IML",
    initials: "JM",
  },
  {
    id: "rodrigo-espinoza",
    name: "Rodrigo Espinoza Vargas",
    profession: "Ingeniero Civil Industrial",
    university: "Pontificia Universidad Católica",
    role: "Socio de ADJ",
    initials: "RE",
  },
  {
    id: "paulina-pinto",
    name: "Paulina Pinto de la Carrera",
    profession: "Ingeniero Comercial",
    university: "Pontificia Universidad Católica",
    role: "Socia de ADJ",
    initials: "PP",
  },
];